// extracted by mini-css-extract-plugin
export default {"stripePayment":"PaymentForm_stripePayment__oyzbs"};